import React, { useState } from 'react';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled, useTheme } from '@mui/material/styles';

const menuData = [
    {
        label: 'VN30',
        subMenu: [],
    },
    {
        label: 'HOSE',
        subMenu: [
            { label: 'HOSE' },
            { label: 'Lô Lẻ' },
            { label: 'Thỏa thuận' },
        ],
    },
    {
        label: 'HNX',
        subMenu: [
            { label: 'HNX' },
            { label: 'Lô Lẻ' },
            { label: 'Thỏa thuận' },
        ],
    },
    {
        label: 'UPCOM',
        subMenu: [
            { label: 'UPCOM' },
            { label: 'Lô Lẻ' },
            { label: 'Thỏa thuận' },
        ],
    },
];

const ActiveButton = styled(Button)<{ active: boolean }>(({ active, theme }) => ({
    color: active ? theme.palette.primary.main : theme.palette.text.primary,
    borderBottom: active ? `1px solid ${theme.palette.primary.main}` : 'none',
    borderRadius: 0,
    padding: '8px 16px',
    transition: 'border-bottom 0.3s ease',
}));

export default function SymbolSelectorMenu(props: any) {
    const theme = useTheme(); // Lấy theme hiện tại
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [currentMenu, setCurrentMenu] = useState<string | null>(null); // Menu đang active
    const [activeMenuItem, setActiveMenuItem] = useState<string | null>(props.idPbTab); // Giữ menu đã click

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>, menu: string) => {
        setAnchorEl(event.currentTarget);
        setCurrentMenu(menu);
        setActiveMenuItem(menu);
        props.onChangeTabs(event, { idPbTab: menu });
    };

    const handleMouseEnterMenu = (event: React.MouseEvent<HTMLElement>, menu: string) => {
        setAnchorEl(event.currentTarget);
        setCurrentMenu(menu);
    };

    const handleMouseLeave = () => {
        setAnchorEl(null);
        setCurrentMenu(null);
    };

    return (
        <Toolbar sx={{ minHeight: '30px !important', padding: '0px !important' }}>
            {menuData.map((menu) => (
                <div key={menu.label} onMouseLeave={handleMouseLeave}>
                    <ActiveButton
                        aria-controls={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup="true"
                        onMouseEnter={(event) => handleMouseEnterMenu(event, menu.label)}
                        onClick={(event) => handleMenuClick(event, menu.label)} // Giữ trạng thái khi click
                        color="inherit"
                        active={activeMenuItem === menu.label} // Giữ trạng thái active sau khi click
                    >
                        {menu.label}
                    </ActiveButton>
                    {menu.subMenu.length > 0 && (
                        <Menu
                            anchorEl={anchorEl}
                            open={currentMenu === menu.label}
                            onClose={handleMouseLeave}
                            MenuListProps={{
                                onMouseLeave: handleMouseLeave,
                            }}
                            PaperProps={{
                                sx: {
                                    backgroundColor: theme.palette.background.default,
                                    border: `1px solid ${theme.palette.text.primary}`,
                                    color: theme.palette.text.primary
                                },
                            }}
                        >
                            {menu.subMenu.map((subMenu) => (
                                <MenuItem
                                    key={subMenu.label}
                                    onClick={(event) => handleMenuClick(event, menu.label)}
                                >
                                    {subMenu.label}
                                </MenuItem>
                            ))}
                        </Menu>
                    )}
                </div>
            ))}
        </Toolbar>
    );
}
